module.exports = __webpack_public_path__ + "static/media/nav-icon-value-inactive.77c870bd.svg";